import { useInView } from "framer-motion"
import { useRef } from "react"
import styled from "styled-components"
import { TextDiv } from "../common/Text"
import { StyledButton } from "../common/Buttons"
import { useNavigate } from "react-router-dom"
import { BsChevronRight } from "react-icons/bs"

const ImageContainer = () => {
  const ref = useRef(null)
  const navigate = useNavigate()

  const handleClick = () => {
    navigate("/quiz")
  }

  const isInView = useInView(ref, { once: true })
  return (
    <Container>
      <ImageDiv ref={ref}>
        <StyledImg src="" alt="#" />
      </ImageDiv>
      <DescriptionContainer>
        <TitleDiv $isInView={isInView}>
          <Title fontWeight="bold" color="var(--custom-deep-dark-brown)">
            학문적성 검사도구
          </Title>
          <SubTitle>College Major Aptitude Test</SubTitle>
        </TitleDiv>
        <Description
          $isInView={isInView}
          $align="end"
          color="var(--custom-dark-brown)"
        >
          {
            "우리나라 주요 4년제 대학 109개 학과의 학문정보를 담고 있는 학문프로파일 개발\n학문프로파일 기반으로 검사자의 학문적성 진단"
          }
        </Description>
        <Buttondiv $isInView={isInView}>
          <StyledButton
            onClick={handleClick}
            $size="small"
            $bgColor="var(--custom-white-smoke-70)"
            $borderColor="var(--custom-dark-brown)"
            $hoverColor="var(--custom-white-smoke)"
            $activeColor="var(--custom-white-smoke)"
            $activeTextColor="var(--custom-deep-dark-brown)"
            $shadow={true}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 10,
            }}
          >
            검사 하러 가기
            <BsChevronRight />
          </StyledButton>
        </Buttondiv>
      </DescriptionContainer>
    </Container>
  )
}

export default ImageContainer

const Container = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`

const ImageDiv = styled.div`
  width: 100vw;
  height: 100%;
  position: relative;
  overflow: hidden;
`

const StyledImg = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.6;
  content: url("./img/siora-photography-ZslFOaqzERU-unsplash.jpg");

  @media ${({ theme }) => theme.device.pc} {
    opacity: 0.7;
    content: url("./img/element5-digital-OyCl7Y4y0Bk-unsplash.jpg");
  }
`

const DescriptionContainer = styled.div`
  margin: 0;
  right: 30px;
  top: 20%;
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  @media ${({ theme }) => theme.device.pc} {
    right: 15%;
  }
`

const TitleDiv = styled.div<{ $isInView: boolean }>`
  transform: ${(props) => (props.$isInView ? "none" : "translateY(200px)")};
  opacity: ${(props) => (props.$isInView ? 1 : 0)};
  transition-property: transform, opacity;
  transition-duration: 0.6s;
  transition-timing-function: ease-in-out;
  transition-delay: 0.5s;
`

const Title = styled(TextDiv)`
  font-size: 36px;

  @media ${({ theme }) => theme.device.pc} {
    font-size: 48px;
  }
`

const SubTitle = styled(TextDiv)`
  font-size: 20px;
  color: var(--custom-dark-brown);
  text-shadow: 2px 2px 4px gray;

  @media ${({ theme }) => theme.device.pc} {
    font-size: 24px;
    color: var(--custom-light-brown);
  }
`

const Description = styled(TextDiv)<{ $isInView: boolean }>`
  text-shadow: 2px 2px 4px var(--custom-white-smoke);
  font-size: 18px;
  font-weight: bold;
  width: 280px;
  margin-top: 45px;

  transform: ${(props) => (props.$isInView ? "none" : "translateY(200px)")};
  opacity: ${(props) => (props.$isInView ? 1 : 0)};
  transition-property: transform, opacity;
  transition-duration: 0.6s;
  transition-timing-function: ease-in-out;
  transition-delay: 0.8s;

  @media ${({ theme }) => theme.device.pc} {
    font-size: 24px;
    width: 100%;
    text-shadow: none;
  }
`

const Buttondiv = styled.div<{ $isInView: boolean }>`
  margin-top: 20px;
  width: 200px;

  opacity: ${(props) => (props.$isInView ? 1 : 0)};
  transition: opacity 1.1s ease-in-out 1.3s;

  @media ${({ theme }) => theme.device.pc} {
    width: 300px;
  }
`
